module.exports = __webpack_public_path__ + "static/media/banner3.192197c2.png";